import React, { Component } from 'react';
import PropTypes from 'prop-types';
import locales from '../locales';
import { version } from '../../package.json';

import * as UTILS_THEMES from '../utils/utilsThemes.js';

class PrivateFooter extends Component {
  constructor(props) {
    super(props);

    this.moduleVersion = version;
    this.themeStyleURL = UTILS_THEMES.getCurrentThemeStyleURL(this.getCurrentTheme());
  }

  getCurrentTheme() {
    let { theme } = this.props;
    return theme;
  }

  getStylesheet() {
    return <link rel="stylesheet" type="text/css" href={this.themeStyleURL} />;
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }

  render() {
    const stylesheet = this.getStylesheet();

    const { loadExternalCSS = true, lang } = this.props;
    const t = locales(lang);

    return (
      <footer data-version={this.moduleVersion} className="md__footer  md__footer_private">
        {loadExternalCSS && stylesheet}
        <div className="md__footer__brand">
          <div className="md__footer__copyright">
            {`${this.getCurrentYear()} © ${t('globalFooter.Legal.copyright')}`}.
          </div>
        </div>
        <div className="md__footer__legal--responsive">
          {`${this.getCurrentYear()} © ${t('globalFooter.Legal.copyright')}`}
        </div>
      </footer>
    );
  }
}

PrivateFooter.propTypes = {
  lang: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  loadExternalCSS: PropTypes.bool,
};

PrivateFooter.defaultProps = {
  version,
};

export default PrivateFooter;
